<div class="create-query-container create-query-container" nzCompact>
  <div class="form-row bg-dark-blue text-white">
    <span class="span-header">Query Details</span>
  </div>
  <br>
  <div class="row form-group">
    <div class="col-md-2">
      <label>Reference Number</label>
    </div>
    <div class="col-md-3">
      <input nz-input nz-input value="{{queryModel.Query_Reference_Number}}" style="font-weight: bold;"
        name="QueryReferenceNumber" type="text" class="form-control" disabled />
    </div>
    <div class="col-md-3 col-md-push-1">
      <label>Date of Request</label>
    </div>
    <div class="col-md-3">
      <input nz-input nz-input value="{{queryModel.Created_Date | date:'dd-MMM-yyyy'}}" name="CreatedDate" type="text"
        class="form-control" disabled />
    </div>
  </div>
  <div class="row form-group">
    <div class="col-md-2">
      <label>Subject</label>
    </div>
    <div class="col-md-3">
      <input nz-input name="Subject" type="text" class="form-control" disabled value="{{queryModel.Subject}}"
        title="{{queryModel.Subject}}" />
    </div>
    <div class="col-md-3 col-md-push-1">
      <label>Request Status</label>
    </div>
    <div class="col-md-3">
      <input nz-input value="{{queryModel.QueryStatus}}" title="{{queryModel.QueryStatus}}" style="font-weight: bold;"
        name="QueryStatus" type="text" class="form-control" disabled />
    </div>

  </div>
  <div class="row form-group">
    <div class="col-md-2">
      <label>Priority</label>
    </div>
    <div class="col-md-3">
      <input nz-input value="{{queryModel.QueryDetail.PriorityLevel}}" title="{{queryModel.QueryDetail.PriorityLevel}}"
        name="PriorityLevel" type="text" class="form-control" disabled />
    </div>
    <div class="col-md-3 col-md-push-1">
      <label>Confidential</label>
    </div>
    <div class="col-md-3">
      <input type="checkbox" class="chckbx-Confidential" name="Partner_Confidential"
        [checked]="queryModel.QueryDetail.Is_Confidential" onclick="return false;" />
    </div>
  </div>
  <div class="row form-group">
    <div class="col-md-2">
      <label>CC Emails</label>
    </div>
    <div class="col-md-3">
      <textarea nz-input type="text" rows="3" class="form-control" name="CCEmails"
        value="{{queryModel.QueryDetail.CCEmails}}" disabled></textarea>
    </div>

    <div class="col-md-3 col-md-push-1" *ngIf="queryModel.CanViewPrevsQueryDtls">
      <label>Query Type</label>
    </div>
    <div class="col-md-3" *ngIf="queryModel.CanViewPrevsQueryDtls">
      <input nz-input value="Re-Opened" name="Query Type" type="text" style="font-weight: bold;" class="form-control"
        disabled />
    </div>

  </div>

  <div class="form-row bg-dark-blue text-white">
    <span class="span-header">Requestor Details</span>
  </div>
  <br>

  <div class="row form-group">
    <div class="col-md-2">
      <label>Requestor Name</label>
    </div>
    <div class="col-md-3">
      <input nz-input value="{{queryModel.RequestorDetail.User_Name}}" title="{{queryModel.RequestorDetail.User_Name}}"
        name="RequestorDetail.User_Name" type="text" class="form-control" disabled />
    </div>
    <div class="col-md-3 col-md-push-1">
      <label>Requestor Email</label>
    </div>
    <div class="col-md-3">
      <input nz-input value="{{queryModel.RequestorDetail.Email}}" name="RequestorDetail.Email" type="text"
        class="form-control" disabled />
    </div>
  </div>

  <div class="row form-group">
    <div class="col-md-2">
      <label>Company:</label>
    </div>
    <div class="col-md-3">
      <input nz-input value="{{queryModel.QueryDetail.CompanyName}}" name="RequestorDetail.CompanyName" type="text"
        class="form-control" disabled />
    </div>
    <div class="col-md-3 col-md-push-1">
      <label>Block</label>
    </div>
    <div class="col-md-3">
      <input nz-input value="{{queryModel.QueryDetail.Block}}" title="{{queryModel.QueryDetail.Block}}"
        name="queryModel.QueryDetail.Block" type="text" class="form-control" disabled />
    </div>
  </div>

  <div class="form-row bg-dark-blue text-white">
    <span class="span-header">Clarification Request Details</span>
  </div>
  <br>
  <div class="row form-group">
    <div class="col-md-2">
      <!-- <label>Block</label> -->
    </div>
    <div class="col-md-3">
      <!-- <input value="{{queryModel.QueryDetail.Block}}" title="{{queryModel.QueryDetail.Block}}"
          name="queryModel.QueryDetail.Block" type="text" class="form-control" disabled /> -->
    </div>
    <div class="col-md-3 col-md-push-1">
    </div>
    <div class="col-md-3" *ngIf="queryModel.CanViewPrevsQueryDtls">
      <button nz-button nzType="primary" routerLink="/clarification-query/view-previous-query-details/{{ queryCode }}">
        Previous Query Resolution Details
      </button>
    </div>
  </div>

  <div class="row form-group">
    <div class="col-md-2">
      <label>Department</label>
    </div>
    <div class="col-md-3">
      <input nz-input value="{{queryModel.QueryDetail.Department}}" title="{{queryModel.QueryDetail.Department}}"
        name="queryModel.QueryDetail.Department" type="text" class="form-control" disabled />
    </div>
    <div class="col-md-3 col-md-push-1">
      <label>Sub Department</label>
    </div>
    <div class="col-md-3">
      <input nz-input value="{{queryModel.QueryDetail.SubDepartment}}" title="{{queryModel.QueryDetail.SubDepartment}}"
        name="queryModel.QueryDetail.SubDepartment" type="text" class="form-control" disabled />
    </div>
  </div>

  <div class="row form-group" *ngIf="CCSubDepartmentsMaster.length > 0">
    <div class="col-md-2">
      <label>CC Sub Departments</label>
    </div>
    <div class="col-md-3">
      <nz-select id="ccSubDepartment" [(ngModel)]="selectedCCSubDepts" nzMode="multiple" nzDisabled
          nzPlaceHolder="Select CC Sub Departments" 
          style="width: 100%;">
          <nz-option *ngFor="let item of CCSubDepartmentsMaster" [nzLabel]="item.item_text"
              [nzValue]="item.item_id"></nz-option>
      </nz-select>      
    </div>
  </div>

  <div class="row form-group" *ngIf="partnerUserMaster.length > 0">
    <div class="col-md-2">
      <label>CC</label>
    </div>
    <div class="col-md-3">      
      <!-- <ng-multiselect-dropdown disabled [(ngModel)]="selectedCCUsers" [ngModelOptions]="{standalone: true}"
          [settings]="dropdownSettings">
        </ng-multiselect-dropdown> -->
        <nz-select id="cc" [(ngModel)]="selectedCCUsers" nzMode="multiple" nzPlaceHolder="Select CC" nzDisabled
              style="width: 100%;">
            <nz-option *ngFor="let item of partnerUserMaster" [nzLabel]="item.item_text"
                [nzValue]="item.item_id"></nz-option>
        </nz-select>
    </div>
  </div>

  <div class="row form-group">
    <div class="col-md-2 required">
      <label>Partner Comments</label>
    </div>
    <div class="col-md-6">
      <textarea nz-input rows="3" ngModel="{{queryModel.QueryDetail.Partner_Comment}}" name="Partner_Comment"
        type="text" disabled class="form-control"></textarea>
    </div>
    <div class="col-md-3">
      <button nz-button nzType="primary" (click)="viewAttachments(true)" >
        View Attachments
      </button>
      <div>
        <label> Attachment count - {{partnerUploadedAttachmtCnt}}</label>
      </div>
    </div>
  </div>

  <div class="row form-group">
    <div class="col-md-2">
      <label>Company Restricted</label>
    </div>
    <div class="col-md-6">
      <input type="checkbox" class="chckbx-Confidential" name="Company_Restricted"
        [checked]="queryModel.QueryDetail.Company_Restricted" onclick="return false;" />
    </div>
  </div>

  <div class="row form-group">
    <div class="col-md-2 required">
      <label>Query Category</label>
    </div>
    <div class="col-md-3">
      <input nz-input value="{{queryModel.QueryDetail.Category}}" title="{{queryModel.QueryDetail.Category}}"
        name="queryModel.QueryDetail.Category" type="text" class="form-control" disabled />
    </div>
    
      <div class="col-md-3 col-md-push-1 required" *ngIf="(queryModel.QueryDetail.Clarification_Cat_Code == '1' || queryModel.QueryDetail.Clarification_Cat_Code =='2')">
        <label>Query Sub Category</label>
      </div>
      <div class="col-md-3" *ngIf="(queryModel.QueryDetail.Clarification_Cat_Code == '1' || queryModel.QueryDetail.Clarification_Cat_Code =='2')">
        <input nz-input value="{{queryModel.QueryDetail.SubCategory}}" title="{{queryModel.QueryDetail.SubCategory}}"
          name="queryModel.QueryDetail.SubCategory" type="text" class="form-control" disabled />
      </div>
    
  </div>

  <div class="row form-group" *ngIf="(queryModel.QueryDetail.Clarification_Cat_Code == '1' || queryModel.QueryDetail.Clarification_Cat_Code == '2'
        && queryModel.QueryDetail.Clarification_SubCat_Code !='' && !isCategoryCommentVisible)">
    <div class="col-md-2">
      <label>Letter Reference Number</label>
    </div>
    <div class="col-md-3">
      <input nz-input value="{{queryModel.QueryDetail.LetterReference_Number}}"
        name="queryModel.QueryDetail.LetterReference_Number" type="text" class="form-control" disabled />
    </div>
  
      <div class="col-md-3 col-md-push-1" *ngIf="isContractNumberVisible">
        <label>Contract Number</label>
      </div>
      <div class="col-md-3" *ngIf="isContractNumberVisible">
        <input nz-input value="{{queryModel.QueryDetail.Contract_Number}}" name="queryModel.QueryDetail.Contract_Number"
          type="text" class="form-control" disabled />
      </div>
   
    
      <div class="col-md-3 col-md-push-1" *ngIf="isAFEVisible">
        <label>AFE Number</label>
      </div>
      <div class="col-md-3" *ngIf="isAFEVisible">
        <input nz-input value="{{queryModel.QueryDetail.AFE_Number}}" name="queryModel.QueryDetail.AFE_Number"
          type="text" class="form-control" disabled />
      </div>
      
      <div class="col-md-3 col-md-push-1" *ngIf="isWOVisible">
        <label>Work Order Number</label>
      </div>
      <div class="col-md-3" *ngIf="isWOVisible">
        <input nz-input value="{{queryModel.QueryDetail.Work_Order_Number}}"
          name="queryModel.QueryDetail.Work_Order_Number" type="text" class="form-control" disabled />
      </div>    
  </div>
  <div
    *ngIf="(queryModel.QueryDetail.Clarification_Cat_Code != '' && queryModel.QueryDetail.Clarification_Cat_Code != '1' && queryModel.QueryDetail.Clarification_Cat_Code != '2') || (isCategoryCommentVisible)">
    <br>
    <div class="row">
      <div class="col-md-2 required">
        <label>Category Comments</label>
      </div>
      <div class="col-md-6">
        <textarea nz-input rows="3" value="{{queryModel.QueryDetail.Category_Comments}}" name="CategoryComment"
          type="text" class="form-control" disabled></textarea>
      </div>
    </div>
  </div>
  <div *ngIf="queryModel.QueryStatusEnum !=queryNewEnum && queryModel.QueryStatusEnum != queryReOpenedEnum"> 
  
    <br>
    <div class="form-row bg-dark-blue text-white">
      <span class="span-header">Query Resolution Details</span>
    </div>
    <br>
    <div class="row" *ngIf="queryModel.QueryDetail.ConsolidatedComment.length > 0">
      <br>
      <div class="col-md-2">
        <label>Consolidated Comments</label>
      </div>
      <div class="col-md-6">
        <div>
          <p id="consolidatedComment" class="consolidate-comments" readonly="readonly" style="font-size: 90%;"
            [innerHTML]="queryModel.QueryDetail.ConsolidatedCommentInString" disabled></p>
        </div>
        <div>
          <a (click)="viewComments()" style="cursor: pointer;text-decoration: underline; ">View Comments</a>
        </div>
      </div>
      <div class="col-md-3">
        <button nz-button nzType="primary" (click)="viewAttachments(false)">
          View Attachments
        </button>
        <div>
          <label>Attachment count - {{internalUserUploadedAttachmtCnt}}</label>
        </div>
      </div>
    </div>
    <div *ngIf="queryModel.QueryStatusEnum == queryResponseEnum">
      <br>
      <div class="row">
        <div class="col-md-2">
          <label>Resolution Comments</label>
        </div>
        <div class="col-md-6">
          <textarea nz-input rows="3" ngModel="{{queryModel.QueryDetail.Resolution_Comment}}" name="Resolution_Comment"
            type="text" disabled class="form-control"></textarea>
        </div>
        <div class="col-md-3" *ngIf="queryModel.QueryDetail.ConsolidatedComment.length == 0">
          <button (click)="viewAttachments(false)" nz-button nzType="primary">
            View Attachments
          </button>
          <div>
            <label>Attachment count - {{internalUserUploadedAttachmtCnt}}</label>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="canViewDeletedComment">
      <br>
      <div class="row">
        <div class="col-md-2">
          <label>Deleted Comment</label>
        </div>
        <div class="col-md-6">
          <textarea rows="3" ngModel="{{queryModel.Delete_Comment}}" name="Delete_Comment" type="text" disabled
            class="form-control"></textarea>
        </div>
        <div class="col-md-3" *ngIf="queryModel.QueryDetail.ConsolidatedComment.length == 0">
          <button (click)="viewAttachments(false)" nz-button nzType="primary">
            View Attachments
          </button>
          <div>
            <label> Attachment count - {{internalUserUploadedAttachmtCnt}}</label>
          </div>
        </div>
      </div>
    </div>
  </div>
  <br>
  <div class="row">
    <div class="col-md-6 col-md-push-2">
      <button (click)="redirectToQueryRequest()" nz-button nzType="primary">
        Back
      </button>
    </div>
  </div>
  <br>
</div>